import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PwaUpdateService } from './core/services/pwa-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private pwaUpdateService: PwaUpdateService,
    private translateService: TranslateService
  ) {
    // Initialize TranslateService with default language
    const savedLanguage = localStorage.getItem('appLang') || 'pl';
    this.translateService.setDefaultLang(savedLanguage);
    this.translateService.use(savedLanguage);
  }

  ngOnInit(): void {
    // Initialize PWA update checking
    this.pwaUpdateService.init();
  }
}
